import { createServices } from '../createServices'

export function initServices () {
  return createServices()
}
